// src/components/landing/WhyChooseUs.jsx
import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import img_why_ceremony from '../../assets/images/landing/why-ceremony.jpg';
import img_why_classroom from '../../assets/images/landing/why-classroom.jpg';
const whyClassroom = img_why_classroom;
const whyCeremony = img_why_ceremony;

const FEATURES = [
  {
    color: 'linear-gradient(135deg,#1d6cf0,#0ea5e9)',
    title: 'Govt. Approved Certificates',
    text: 'Government of Kerala has approved the DCA Course conducted by BSS and the certificate issued therein for the purpose of appointment to suitable posts in public services.',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
    ),
  },
  {
    color: 'linear-gradient(135deg,#10b981,#059669)',
    title: '300+ Expert Faculties',
    text: 'Qualified trainers with real industry experience across all 14 Kerala districts.',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
    ),
  },
  {
    color: 'linear-gradient(135deg,#7c3aed,#5b21b6)',
    title: 'Flexible Learning Schedule',
    text: 'Morning, evening, and weekend batches across 150+ centers in Kerala.',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
    ),
  },
  {
    color: 'linear-gradient(135deg,#f59e0b,#d97706)',
    title: 'Trusted Since Inception',
    text: 'Backed by Bharat Sevak Samaj — a national development agency of the Govt. of India.',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
    ),
  },
];

export default function WhyChooseUs() {
  return (
    <Box id="about" sx={{ bgcolor: '#ffffff', py: { xs: 8, md: 12 }, px: { xs: 3, md: 8 } }}>
      <Grid container spacing={8} sx={{ maxWidth: 1040, mx: 'auto' }} alignItems="center">
        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7 }}
          >
            <Box sx={{ position: 'relative' }}>
              <Box sx={{
                width: '100%', height: { xs: 280, md: 420 }, borderRadius: 5.5, overflow: 'hidden',
                border: '1px solid #e2eaf5', boxShadow: '0 20px 60px rgba(29,108,240,0.12)',
              }}>
                <Box component="img" src={whyClassroom} alt="BSS IT Mission Indian classroom"
                  sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </Box>
              <Box sx={{
                position: 'absolute', bottom: -20, right: -20,
                width: 160, height: 120, borderRadius: 4, overflow: 'hidden',
                border: '3px solid #ffffff',
                boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
              }}>
                <Box component="img" src={whyCeremony} alt="Certificate ceremony"
                  sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </Box>
            </Box>
          </motion.div>
        </Grid>

        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7, delay: 0.15 }}
          >
            <Typography sx={{ fontSize: '0.68rem', fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: '#1d6cf0', mb: 1.5 }}>
              Why BSS IT Mission
            </Typography>
            <Typography sx={{ fontSize: { xs: '1.7rem', md: '2.3rem' }, fontWeight: 900, letterSpacing: '-0.5px', color: '#1e293b', mb: 2, lineHeight: 1.2 }}>
              Education That Opens<br />Government Doors
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              {FEATURES.map((f) => (
                <Box key={f.title} sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                  <Box sx={{ width: 44, height: 44, borderRadius: 3, background: f.color, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, boxShadow: '0 4px 14px rgba(0,0,0,0.15)' }}>
                    {f.icon}
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#1e293b', mb: 0.5 }}>{f.title}</Typography>
                    <Typography sx={{ fontSize: '0.85rem', color: '#64748b', lineHeight: 1.6 }}>{f.text}</Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </motion.div>
        </Grid>
      </Grid>
    </Box>
  );
}
